export const addCustomTagEvent = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
};
